export const lvzMarkerDataSelector = ({lvzMarkerData}) => lvzMarkerData